module.exports = __webpack_public_path__ + "static/media/10UNOHRLLS8.5cb7542d.jpg";